import React, { useEffect, useRef, useState } from 'react';

const FactCard = ({ text, index, delay = 0 }) => {
  const [isVisible, setIsVisible] = useState(false);
  const cardRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            setIsVisible(true);
          }, delay);
        }
      },
      { threshold: 0.1 }
    );

    if (cardRef.current) {
      observer.observe(cardRef.current);
    }

    return () => {
      if (cardRef.current) {
        observer.unobserve(cardRef.current);
      }
    };
  }, [delay]);

  return (
    <div 
      ref={cardRef}
      className={`bg-[#f5faff] rounded-lg p-6 border border-blue-200 shadow-sm hover:shadow-md transition-all duration-300 transform ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
      }`}
    >
      <div className="flex items-start gap-4">
        <div className="bg-purple-100 text-purple-600 font-bold h-8 w-8 rounded-full flex items-center justify-center flex-shrink-0">
          {index}
        </div>
        <p className="text-gray-700">{text}</p>
      </div>
    </div>
  );
};

export default FactCard;
